// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterCurrencySelector_wrapper__ZDUz9","choosen":"FooterCurrencySelector_choosen__Uuihk","container":"FooterCurrencySelector_container__MdGoW"};